import { ActionTree, MutationTree, Store } from 'vuex'
import { GET_LOYALTY_ACCOUNT_AMOUNT } from '@@/graphQL/web'
import { ApolloClient } from 'apollo-client'
import { NormalizedCacheObject } from 'apollo-cache-inmemory/lib/types'

type GraphQLClient = ApolloClient<NormalizedCacheObject>

export type Address = {
  city: {
    id: number;
    name: string;
  },
  street: {
    id: number;
    name: string;
  },
  building: string;
  flat: string;
}

export enum GENDER {
  FEMALE = 'female',
  MALE = 'male'
}

export type LoyaltyAccount = {
  id: number|null
  amount: number|null
}

export type State = {
  firstName: string|null;
  lastName: string|null;
  gender: GENDER|null;
  birthday: string|null;
  email: string|null;
  phone: string|null;
  address: Address;
  bonuses: number;
  authenticated: boolean;
  loyaltyAccount: LoyaltyAccount|null;
}

export const state = (): State => ({
  firstName: null,
  lastName: null,
  gender: null,
  birthday: null,
  email: null,
  phone: null,
  address: {
    city: { id: 0, name: '' },
    street: { id: 0, name: '' },
    building: '',
    flat: '',
  },
  bonuses: 0, // deprecated
  authenticated: false,
  loyaltyAccount: null,
})

export const mutations: MutationTree<State> = {
  set (state: State, values: Partial<State>) {
    state.firstName = values.firstName ?? state.firstName
    state.lastName = values.lastName ?? state.lastName
    state.gender = values.gender ?? state.gender
    state.birthday = values.birthday ?? state.birthday
    state.email = values.email ?? state.email
    state.phone = values.phone ?? state.phone
    state.address = values.address ?? state.address
    state.bonuses = values.bonuses ?? state.bonuses
    state.authenticated = values.authenticated ?? state.authenticated
    state.loyaltyAccount = values.loyaltyAccount ?? state.loyaltyAccount
  },

  reset (state: State) {
    state.firstName = null
    state.lastName = null
    state.gender = null
    state.birthday = null
    state.email = null
    state.phone = null
    state.address = {
      city: { id: 0, name: '' },
      street: { id: 0, name: '' },
      building: '',
      flat: '',
    }
    state.bonuses = 0
    state.authenticated = false
    state.loyaltyAccount = null
  },
}

export const actions: ActionTree<State, State> = {
  async loadLoyalty (this: Store<State>, { commit, state }) {
    if (!state.authenticated) {
      return
    }

    commit('lock', null, { root: true })

    const apollo: GraphQLClient = this.app.apolloProvider?.defaultClient as GraphQLClient
    try {
      const { data: { loyaltyAccount } } = await apollo.query({
        query: GET_LOYALTY_ACCOUNT_AMOUNT,
      })

      commit('set', { loyaltyAccount })
    } catch (e) {
      console.error(e)
    }

    commit('unlock', null, { root: true })
  },
}
